import { DateOption, DateOptionsDateRange } from 'components/account-overview-chart/types';
import { DateTime } from 'luxon';
import { Account, Campaign } from 'types/domain';
import { StateCreator } from 'zustand';

export interface OnboardingChartState {
    selectedCampaignIds: { [id: Account['id']]: Campaign['id'] };
    selectedDateOption: DateOption;
    customDate: DateOptionsDateRange;
    setChartParams: (
        selectedDateOption: OnboardingChartState['selectedDateOption'],
        customDate: OnboardingChartState['customDate'],
        selectedCampaignId: OnboardingChartState['selectedCampaignIds'],
    ) => void;
}

export const createOnboardingChartParamsSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    OnboardingChartState
> = set => ({
    customDate: {
        start_date: DateTime.now().toISO(),
        end_date: DateTime.now().endOf('day').toISO(),
    },
    selectedDateOption: DateOption.MonthToDate,
    selectedCampaignIds: {},
    setChartParams: (selectedDateOption, customDate, selectedCampaignIds) =>
        set({
            selectedDateOption,
            customDate,
            selectedCampaignIds,
        }),
});
